import type { FC } from "react";
import { ClientPortfolioToolTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailRow } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailRow";

const ToolResources = Resources.PortfolioDetail.LifeInsurance.InvestmentTool;

type Props = {
	tool: { type?: ClientPortfolioToolTypeEnum | null };
};

export const ToolTypeRow: FC<Props> = ({ tool }) => {
	const { t } = useResource();

	return (
		<DetailRow
			label={t(ToolResources.type)}
			value={t(
				ToolResources.Type[tool.type ?? ClientPortfolioToolTypeEnum.Other],
			)}
		/>
	);
};
